'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganisationModel = function () {
  function OrganisationModel(data) {
    _classCallCheck(this, OrganisationModel);

    this.locations = [];
    this.logentries = [];
    this.location = null;

    this.values = {
      id: null,
      image: null,
      name: null,
      location_id: null,
      vat: null,
      coc: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(OrganisationModel, [{
    key: 'getTitle',
    value: function getTitle() {
      return [this.values.name].join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      if (this.location) {
        return [this.location.values.visitcity].join(' ');
      } else {
        return '';
      }
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      return this.values.image;
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 1).toUpperCase();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.location) {
        title.push(this.location.values.visitcity);
      }

      if (this.values.name) {
        title.push(this.values.name);
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return OrganisationModel;
}();

exports.default = OrganisationModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/organisation/model/OrganisationModel.js
// module id = 10
// module chunks = 0